module.exports = __webpack_public_path__ + "static/media/day15_music.babe14b6.gif";